import { Alert, Button, Inline } from "@evolua/ui";
import { useEffect, useState } from "react";

type UpdateFn = (() => Promise<void>) | undefined;

let pendingUpdate: UpdateFn;
const listeners = new Set<() => void>();

export function bindSwUpdate(updateSW: UpdateFn): void {
  pendingUpdate = updateSW;
  for (const listener of listeners) listener();
}

/**
 * Banner quando há nova versão do service worker (registerType: prompt).
 */
export function SwUpdateBanner() {
  const [ready, setReady] = useState(() => Boolean(pendingUpdate));
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onChange = () => setReady(Boolean(pendingUpdate));
    listeners.add(onChange);
    return () => {
      listeners.delete(onChange);
    };
  }, []);

  if (!ready || !pendingUpdate) return null;

  return (
    <Alert tone="info" className="evolua-sw-update-banner" role="status">
      <Inline justify="between" gap={2}>
        <span>Nova versão do app disponível.</span>
        <Button
          type="button"
          size="sm"
          loading={busy}
          onClick={() => {
            setBusy(true);
            void pendingUpdate?.()
              .catch(() => {
                setBusy(false);
              })
              .finally(() => {
                /* reload handled by updateSW(true) */
              });
          }}
        >
          Atualizar
        </Button>
      </Inline>
    </Alert>
  );
}
